import React from 'react';

const TwaddanCarWashApp = () => {
  return (
    <div style={{ width: '100%', height: '100vh', overflow: 'hidden' }}>
      <iframe
        src="/projectList/twaddan.html"
        title="Twadden App"
        style={{ width: '100%', height: '100%', border: 'none' }}
      />
     
    </div>
    
  );
}

export default TwaddanCarWashApp;